import { emailValidators } from '@cube3/main/src/components/app/layout/AccountPages/views/LoginView/utils/validators';
import { validate } from 'jsonschema';
import { validEmailaddress } from './validators';

const ERROR_MESSAGE = {
  REQUIRED: 'Field can not be empty'
};

// TODO: actually format errors based on error codes or something
const formatErrors = (errors) => {
  if (errors?.length > 0) {
    console.warn('jsonschema errors', errors);
    switch (errors[0].name) {
      case 'required':
        return ERROR_MESSAGE.REQUIRED;
      case 'minLength':
        if (errors[0].argument === 1) {
          return ERROR_MESSAGE.REQUIRED;
        }
        break;
      case 'enum':
        return `Allowed values: ${errors[0].argument.join(', ')}`;
      case 'oneOf':
        return ERROR_MESSAGE.REQUIRED;

      // waterfall select
      case 'minItems':
        return 'Select at least one option';
      default:
        break;
    }

    return errors[0].message || `This does not match the required format.`; // TODO: Expand in such a way that we look at what errors the schema returns
  }
};

const isResources = (value) => {
  return !value?.filter((item) => !item.id || !item.type).length;
};

export const makeValidator = (required, schemaString, value_type) => {
  const schema = JSON.parse(schemaString);

  return (value, allValues, props, name) => {
    if (required && (!value || value.length === 0)) {
      switch (value_type) {
        case 'number':
          if (value === 0) {
            // don't show error if type 0
            break;
          }
          break;
        case 'multiselect':
          if (!name) {
            break;
          }
          return ERROR_MESSAGE.REQUIRED;
        default:
          return ERROR_MESSAGE.REQUIRED;
      }
    }

    const valid = validate(value, schema);
    switch (value_type) {
      case 'resource_picker':
        if (schema.title !== 'ContractRecipients' && !isResources(value)) {
          return formatErrors(['Not a valid resource']);
        } else {
          return undefined;
        }
      case 'date':
        if (!value) return undefined; // skip json schema validation if there is no value for `year_only` date type
        break;
      case 'select': // don't show type error if the field is not required and nothing is selected
        if (!value && !required) {
          return undefined;
        }
        break;
      case 'waterfall_select': {
        const errors = validate(value?.value, schema).errors;
        if (errors?.[0]?.name === 'oneOf' && !required) {
          return undefined;
        }
        return formatErrors(errors);
      }
      case 'checkbox':
        return Array.isArray(value) &&
          schema.maxLength &&
          value.length > schema.maxLength
          ? `Select less than ${schema.maxLength} options`
          : '';
      case 'phone_number':
        return value && !valid.valid ? 'Invalid phone number' : '';
      case 'email':
        return !value && !required
          ? ''
          : validEmailaddress(value, allValues, props, name);
      default:
        return formatErrors(valid.errors);
    }
  };
};
